"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$list = exports.$sublist1 = exports.$sublist2 = exports.$sublist3 = exports.makelistOrSublistRule = exports.listOrSublistToLines = void 0;
const line_1 = require("../../../node/cst/line");
const std_1 = require("../../../law/std");
const std = __importStar(require("../../../law/std"));
const columnsOrSentences_1 = require("./columnsOrSentences");
const util_1 = require("../util");
const factory_1 = __importDefault(require("../factory"));
const toCSTSettings_1 = __importDefault(require("../toCSTSettings"));
const util_2 = require("../../../util");
const el_1 = require("../../../node/el");
/**
 * The renderer for List or sublist ({@link std.ListOrSublist | ListOrSublist}). Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$list.spec.ts) for examples.
 */
const listOrSublistToLines = (listOrSublist, indentTexts) => {
    const lines = [];
    const childrenIndentTexts = [...indentTexts, toCSTSettings_1.default.INDENT];
    for (const child of listOrSublist.children) {
        if ((0, std_1.isListOrSublistSentence)(child)) {
            lines.push(new line_1.TableColumnLine({
                range: null,
                indentTexts,
                firstColumnIndicator: "",
                midIndicatorsSpace: "",
                columnIndicator: "-",
                midSpace: " ",
                attrEntries: [],
                multilineIndicator: "",
                sentencesArray: (0, columnsOrSentences_1.columnsOrSentencesToSentencesArray)(child.children),
                lineEndText: toCSTSettings_1.default.EOL,
            }));
            // lines.push(new OtherLine(
            //     null,
            //     indentTexts.length,
            //     indentTexts,
            //     [],
            //     columnsOrSentencesToSentencesArray(child.children),
            //     CST.EOL,
            // ));
        }
        else if ((0, std_1.isListOrSublist)(child)) {
            const listOrSublistLines = (0, exports.listOrSublistToLines)(child, childrenIndentTexts);
            lines.push(...listOrSublistLines);
        }
        else {
            (0, util_2.assertNever)(child);
        }
    }
    return lines;
};
exports.listOrSublistToLines = listOrSublistToLines;
const makelistOrSublistRule = (ruleName, tag, nextSublistRule) => {
    const sentenceTag = std.listOrSublistSentenceTags[std.listOrSublistTags.indexOf(tag)];
    const sublistsBlockRule = nextSublistRule
        ? (factory_1.default
            .sequence(s => s
            .and(r => r
            .ref((0, util_1.makeIndentBlockWithCaptureRule)(`$${tag.toLowerCase()}ChildrenBlock`, nextSublistRule)), "block")
            .action(({ block }) => {
            return {
                value: block.value.map(v => v.value),
                errors: [
                    ...block.value.map(v => v.errors).flat(),
                    ...block.errors,
                ]
            };
        })))
        : null;
    return factory_1.default
        .withName(ruleName)
        .sequence(s => s
        .and(r => r
        .oneMatch(({ item }) => {
        if (item.type === line_1.LineType.TBL
            && item.line.firstColumnIndicator === "") {
            return item;
        }
        else {
            return null;
        }
    }), "line")
        .andOmit(r => r.zeroOrMore(() => util_1.$blankLine))
        .and(r => r
        .zeroOrOne(sublistsBlockRule
        ? sublistsBlockRule
        : r
            .sequence(s => s
            .and(r => r.assert(() => true))
            .action(() => null))), "childrenBlock")
        .action(({ line, childrenBlock }) => {
        const children = [];
        const errors = [];
        const listOrSublistSentenceChildren = (0, columnsOrSentences_1.sentencesArrayToColumnsOrSentences)(line.line.sentencesArray);
        const listOrSublistSentence = (0, std_1.newStdEL)(sentenceTag, {}, listOrSublistSentenceChildren, (0, el_1.rangeOfELs)(listOrSublistSentenceChildren));
        children.push(listOrSublistSentence);
        if (childrenBlock) {
            children.push(...childrenBlock.value);
            errors.push(...childrenBlock.errors);
        }
        const pos = line.line.indentsEndPos;
        const range = (0, el_1.rangeOfELs)(children) ?? (pos !== null ? [pos, pos] : null);
        if (range && pos !== null) {
            range[0] = pos;
        }
        const listOrSublist = (0, std_1.newStdEL)(tag, {}, children, range);
        return {
            value: listOrSublist,
            errors,
        };
    }));
};
exports.makelistOrSublistRule = makelistOrSublistRule;
/**
 * The parser rule for {@link std.Sublist3}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$list.spec.ts) for examples.
 */
exports.$sublist3 = (0, exports.makelistOrSublistRule)("$sublist3", "Sublist3", null);
/**
 * The parser rule for {@link std.Sublist2}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$list.spec.ts) for examples.
 */
exports.$sublist2 = (0, exports.makelistOrSublistRule)("$sublist2", "Sublist2", exports.$sublist3);
/**
 * The parser rule for {@link std.Sublist1}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$list.spec.ts) for examples.
 */
exports.$sublist1 = (0, exports.makelistOrSublistRule)("$sublist1", "Sublist1", exports.$sublist2);
/**
 * The parser rule for {@link std.List}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$list.spec.ts) for examples.
 */
exports.$list = (0, exports.makelistOrSublistRule)("$list", "List", exports.$sublist1);
// export const $listsOuter = makeIndentBlockWithCaptureRule(
//     "$listsOuter",
//     (factory.ref(() => $list)),
// );
//# sourceMappingURL=$list.js.map